import { initMap } from '../../../../../../themes/custom/ev_theme/frontend/js/components/loadMap';
import { setSlider, bindRangeInputs, setRangeHint } from '../filters/sliderRange';
import { closeMap } from '../map';
import { loadSliderHiglighted, loadWithoutResults } from '../script';
import { data_list, list_filters, setFechaList, setFeatureList, data_select } from './results-state';
import { filterString, orderValues } from './results-query';
import { fields, renderFilters, loadChangeFilters } from '../filters/filters';
window.loadOrder = loadOrder;
export function renderResultsPageData(data) {
    var _a, _b;
    const numberTotal = data.NumItems;
    const numberTotalElement = document.getElementById('number-total');
    if (numberTotalElement) {
        numberTotalElement.innerHTML = numberTotal.toString();
    }
    if (numberTotal <= 12) {
        (_a = document.getElementById('more-results')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
    }
    else {
        (_b = document.getElementById('more-results')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    }
    initMap();
    loadWithoutResults(numberTotal);
    loadInfoData(data, fields);
    loadSliderHiglighted('featuredProjectsResults');
    loadFilterOrder();
    setSlider('area');
    setSlider('precio');
    bindRangeInputs('area');
    bindRangeInputs('precio');
    setRangeHint('area');
    setRangeHint('precio');
    renderFilters(false);
}
export function loadInfoData(data, fields) {
    var _a, _b, _c, _d;
    const facetas = data.facetas;
    data_list.tipo_list = facetas.property_type;
    data_list.department_list = facetas.field_location_department ? facetas.field_location_department.filter((x) => x.parent == 0) : [];
    data_list.city_list = facetas.project_city;
    data_list.constructor_highlight = facetas.field_builder_id;
    setFechaList(orderYearsList(facetas.fecha_de_entrega_anio));
    setFeatureList(facetas.project_feature);
    if (!(((_a = data_list === null || data_list === void 0 ? void 0 : data_list.constructor_highlight) === null || _a === void 0 ? void 0 : _a.length) > 0)) {
        (_b = fields['constructor_highlight_value']) === null || _b === void 0 ? void 0 : _b.setAttribute('disabled', 'true');
    }
    else {
        (_c = fields['constructor_highlight_value']) === null || _c === void 0 ? void 0 : _c.removeAttribute('disabled');
    }
    if (data_list.city_list && data_list.city_list.length > 0) {
        data_list.zone_list = facetas.project_zone;
        if (data_list.zone_list.length > 0) {
            data_list.sector_list = facetas.project_neighborhood;
        }
    }
    const departmentField = fields['department_list'];
    const cityField = fields['cities'];
    const zoneField = fields['zone'];
    const sectorField = fields['sector'];
    const ciudadValue = cityField === null || cityField === void 0 ? void 0 : cityField.value;
    if (ciudadValue) {
        const lastItem = data_list.department_list.slice(-1);
        departmentField.value = ((_d = lastItem[0]) === null || _d === void 0 ? void 0 : _d.label) || '';
        const ciudad = data_list.city_list.find(element => element.tid === ciudadValue);
        cityField.value = (ciudad === null || ciudad === void 0 ? void 0 : ciudad.label) || ciudadValue;
        const zoneValue = zoneField.value;
        if (zoneValue) {
            const zone = data_list.zone_list.find(element => element.tid === zoneValue);
            zoneField.value = (zone === null || zone === void 0 ? void 0 : zone.label) || zoneValue;
            if (sectorField === null || sectorField === void 0 ? void 0 : sectorField.value) {
                const sector = data_list.sector_list.find(element => element.tid === (sectorField === null || sectorField === void 0 ? void 0 : sectorField.value));
                sectorField.value = (sector === null || sector === void 0 ? void 0 : sector.label) || '';
            }
        }
    }
    else {
        zoneField === null || zoneField === void 0 ? void 0 : zoneField.setAttribute('disabled', 'true');
    }
    if ((zoneField === null || zoneField === void 0 ? void 0 : zoneField.value.length) <= 0) {
        sectorField === null || sectorField === void 0 ? void 0 : sectorField.setAttribute('disabled', 'true');
    }
    let filters = filterString();
    if (filters.includes('project') && !filters.includes('project_collection')) {
        cityField === null || cityField === void 0 ? void 0 : cityField.setAttribute('disabled', 'true');
    }
    list_filters.precio_list = orderValues(facetas.typology_price);
    list_filters.area_list = orderValues(facetas.area_built);
    list_filters.alcoba_list = orderValues(facetas.bedrooms);
    list_filters.banio_list = orderValues(facetas.bathrooms);
    list_filters.garage_list = orderValues(facetas.garages);
    list_filters.estrato_list = orderValues(facetas.project_feature_stratum);
}
export function orderYearsList(arrayToParse = []) {
    return arrayToParse
        .map((element) => ({ ...element, filter: element.filter.replace(/"/g, '') }))
        .sort((a, b) => parseInt(a.filter, 10) - parseInt(b.filter, 10));
}
let order_list = [
    //{ id: 'order1', label: 'Más Reciente', tipo: 'create', modo: 'DESC' },
    { id: 'order2', label: 'Menor Área', tipo: 'area', modo: 'ASC' },
    { id: 'order3', label: 'Mayor Área', tipo: 'area', modo: 'DESC' },
    { id: 'order4', label: 'Menor Precio', tipo: 'precio', modo: 'ASC' },
    { id: 'order5', label: 'Mayor Precio', tipo: 'precio', modo: 'DESC' },
    { id: 'order6', label: 'Entregas más próximas', tipo: 'delivery', modo: 'ASC' },
    //{ id: 'order7', label: 'Entregas más lejanas', tipo: 'delivery', modo: 'DESC' },
];
export function loadFilterOrder() {
    const orders = ['mobile', 'desktop'];
    orders.forEach(itemOrder => {
        order_list.forEach(item => {
            var _a;
            const li = document.createElement('li');
            const input = document.createElement('input');
            const label = document.createElement('label');
            const isDesktop = itemOrder == 'desktop';
            let orderType = "";
            input.setAttribute('onclick', `loadOrder('${item.id}', '${item.label}')`);
            input.type = 'checkbox';
            input.id = isDesktop ? `desktop-order-${item.id}` : item.id;
            label.textContent = item.label;
            label.setAttribute('for', input.id);
            if (isDesktop) {
                orderType = '.js-results-order';
                li.id = `order-item-desktop-${item.id}`;
                li.classList.add('ev-check-list-item');
                input.classList.add('ev-check-input');
                label.classList.add('ev-check-input__label');
            }
            else {
                orderType = '.js-results-order-mobil';
                li.id = `order-item-${item.id}`;
                li.classList.add('order-filter');
                input.classList.add('order-filter__input');
                label.classList.add('order-filter__label');
            }
            li.appendChild(input);
            li.appendChild(label);
            (_a = document.querySelector(orderType + ' .js-results-content-filters')) === null || _a === void 0 ? void 0 : _a.appendChild(li);
        });
    });
}
function loadOrder(id, label) {
    const order = order_list.find(x => x.id === id);
    if (!order)
        return;
    data_select["order"][0] = order;
    const input = document.getElementById("loadOrderInput");
    if (input) {
        input.setAttribute("placeholder", `Ordenar por ${label}`);
    }
    checkedFilTerOrder(data_select['order'][0].id);
    setTimeout(() => {
        let filter = document.querySelector(".js-results-order .js-results-content-filters");
        if (screen.width < 1000) {
            filter = document.querySelector(".filters-order-mobile");
        }
        filter === null || filter === void 0 ? void 0 : filter.classList.remove("d-block");
        filter === null || filter === void 0 ? void 0 : filter.classList.add('hidden-filter');
    }, 200);
    const data = `${order.tipo},${order.modo}`;
    loadChangeFilters(data, 'sort', false);
    const contentMap = document.getElementById("content-map");
    if (contentMap && !contentMap.classList.contains("d-none")) {
        closeMap();
        const toggle = document.getElementById("map-toggle");
        if (toggle) {
            toggle.checked = false;
        }
    }
    // Force inpun unchek mark
    let inputId = `desktop-order-${id}`;
    const checkbox = document.getElementById(inputId);
    const status = checkbox === null || checkbox === void 0 ? void 0 : checkbox.getAttribute('status');
    if (status && checkbox) {
        checkbox.checked = false;
        checkbox.removeAttribute('status');
    }
    else {
        checkbox === null || checkbox === void 0 ? void 0 : checkbox.setAttribute('status', 'true');
    }
}
function checkedFilTerOrder(id) {
    order_list.forEach(a => {
        const desktopOrder = document.getElementById("desktop-order-" + a.id);
        const orderItem = document.getElementById("order-item-" + a.id);
        const mainInput = document.getElementById(a.id);
        if (a.id === id) {
            desktopOrder.checked = true;
            orderItem === null || orderItem === void 0 ? void 0 : orderItem.classList.add("order-filter--selected");
            mainInput.checked = true;
        }
        else {
            desktopOrder.checked = false;
            orderItem === null || orderItem === void 0 ? void 0 : orderItem.classList.remove("order-filter--selected");
            mainInput.checked = false;
        }
    });
}
export function adjustColor(baseColor) {
    var _a;
    const rgb = (_a = baseColor.substring(1).match(/.{2}/g)) === null || _a === void 0 ? void 0 : _a.map(x => parseInt(x, 16));
    if (!rgb)
        return baseColor;
    const [r, g, b] = rgb;
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
    const amount = luminance < 128 ? 80 : -80;
    const adjusted = rgb.map(c => {
        const newVal = c + amount;
        return Math.max(0, Math.min(255, newVal));
    });
    return `#${adjusted.map(c => c.toString(16).padStart(2, '0')).join('')}`;
}
